module.exports = __webpack_public_path__ + "toolkit-static/img/2-404.be47cdee.png";